import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';

import { FuseShortcutsModule } from '@fuse/components';


import { ToolbarComponent, PhotoUserDialogComponent, LogoutDialogComponent, SafeHtml } from 'app/layout/components/toolbar/toolbar.component';

import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    imports: [
    RouterModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatToolbarModule,
    MatDialogModule,
    MatTooltipModule,
    FuseShortcutsModule,
    MatSelectModule,
    TranslateModule,
    ToolbarComponent,
    LogoutDialogComponent,
    PhotoUserDialogComponent,
    SafeHtml
],
    exports: [
        ToolbarComponent,
    ]
})
export class ToolbarModule
{
}
